<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 12 12" fill="none" :class="color">
        <path
            d="M1.30017 5.99883C1.30017 3.40309 3.40442 1.29883 6.00015 1.29883C6.90873 1.29883 7.75745 1.55693 8.47648 2.00345L8.95118 1.52875C9.07988 1.40005 9.27343 1.36155 9.44159 1.4312C9.60974 1.50085 9.71938 1.66494 9.71938 1.84695V3.43794C9.71938 3.55729 9.67197 3.67175 9.58758 3.75614C9.50318 3.84053 9.38873 3.88794 9.26938 3.88794H7.67839C7.49639 3.88794 7.3323 3.7783 7.26265 3.61015C7.193 3.44199 7.2315 3.24844 7.3602 3.11974L7.81866 2.66128C7.27853 2.3663 6.65907 2.19883 6.00015 2.19883C3.90148 2.19883 2.20017 3.90015 2.20017 5.99883C2.20017 6.25358 2.22517 6.50205 2.27273 6.74205C2.32103 6.98584 2.16256 7.22262 1.91877 7.27093C1.67499 7.31923 1.4382 7.16076 1.38989 6.91697C1.33099 6.61968 1.30017 6.31263 1.30017 5.99883Z"
            fill="currentColor" />
        <path
            d="M10.0816 4.72839C10.3254 4.6801 10.5622 4.83858 10.6105 5.08237C10.6693 5.3796 10.7001 5.68656 10.7001 6.00028C10.7001 8.59602 8.59589 10.7003 6.00016 10.7003C5.09185 10.7003 4.24336 10.4423 3.52446 9.99605L3.0479 10.4726C2.9192 10.6013 2.72565 10.6398 2.55749 10.5702C2.38934 10.5005 2.2797 10.3364 2.2797 10.1544L2.2797 8.56343C2.2797 8.44408 2.32711 8.32962 2.4115 8.24523C2.4959 8.16084 2.61035 8.11343 2.7297 8.11343H4.32068C4.50269 8.11343 4.66678 8.22307 4.73643 8.39122C4.80608 8.55937 4.76758 8.75293 4.63888 8.88163L4.18232 9.33819C4.72229 9.63294 5.34151 9.80028 6.00016 9.80028C8.09884 9.80028 9.80015 8.09896 9.80015 6.00028C9.80015 5.7456 9.77516 5.4972 9.72763 5.25726C9.67934 5.01346 9.83782 4.77668 10.0816 4.72839Z"
            fill="currentColor" />
        <path
            d="M5.70006 3.5C5.94859 3.5 6.15006 3.70147 6.15006 3.95V6.26366L7.25563 7.36924C7.43136 7.54497 7.43136 7.8299 7.25563 8.00564C7.07989 8.18137 6.79497 8.18137 6.61923 8.00564L5.3818 6.7682C5.29204 6.67843 5.24812 6.56018 5.25006 6.44254V3.95C5.25006 3.70147 5.45153 3.5 5.70006 3.5Z"
            fill="currentColor" />
    </svg>
</template>

<script>
export default {
    name: 'person-add-icon',
    props: {
        width: {
            type: [String, Number],
            default: 12,
        },
        height: {
            type: [String, Number],
            default: 12,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'REGULAR',
        },
    },
};
</script>
